import clsx from 'clsx';
import React from 'react';
import styles from './PageLayout.module.scss';

export type PageLayoutProps = {
  /**
   * The content to render inside the page.
   */
  children: React.ReactNode;
  /** Optional property for overriding styles. */
  className?: string;
  /** Optional property for overriding styles. */
  style?: React.CSSProperties;
};

/**
 * A layout component that provides a consistent structure for product pages.
 * It has built-in responsive behavior.
 */
export const PageLayout = ({ children, className, style }: PageLayoutProps) => {
  return (
    <div
      className={clsx(styles.layoutWrapper, className)}
      data-zds
      style={style}
    >
      {children}
    </div>
  );
};
